import { render } from "./EnbSeoFrenteLoja.vue?vue&type=template&id=8fee7edc"
import script from "./EnbSeoFrenteLoja.vue?vue&type=script&lang=js"
export * from "./EnbSeoFrenteLoja.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__